import classnames from 'classnames';
import React from 'react';

import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

import styles from './defaultIconStyles.css';

export function IconCopy({ className = '', ...restProps }: IconProps) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            className={classnames(styles.main, className)}
            {...restProps}
        >
            <path
                className={styles.colored}
                d="M9 16a2 2 0 0 0 2-2H6c-1.95 0-3-1.19-3-2.98V4a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h6zm3-3H6a2 2 0 0 1-2-2V3c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2zM8.5 8h-2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm3-2h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0-2h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
            />
        </svg>
    );
}

export default IconCopy;
